const province = [
	{
		code: 1,
		text: "北京市"
	},
	{
		code: 1,
		text: "天津市"
	},
	{
		code: 1,
		text: "河北省"
	},
	{
		code: 1,
		text: "山西省"
	},
	{
		code: 1,
		text: "内蒙古"
	},
	{
		code: 1,
		text: "辽宁省"
	},
	{
		code: 1,
		text: "吉林省"
	},
	{
		code: 1,
		text: "黑龙江省"
	},
	{
		code: 1,
		text: "上海市"
	},
	{
		code: 1,
		text: "辽宁省"
	},
	{
		code: 1,
		text: "吉林省"
	},
	{
		code: 1,
		text: "黑龙江省"
	}
	// {
	//   code: 1,
	//   text: "上海市",
	// },
]

export default province
